// Schema version 3: Div rework — rewrite clock-synced bar-fraction rates to
// note-value (beat-anchored) strings (MDL-288, spec 131661837 §4).
//
// The old sub-bar fractions were labelled with note-value names that were only
// true in 4/4 ("1/4" read as a crotchet but is a bar fraction). We rewrite each
// to a note-value duration REGARDLESS of the patch's meter: for 4/4 all but
// "1/3" are exactly sound-preserving; for other meters they deliberately correct
// the patch to what the labels always claimed. Bar strings ("1".."16") and Hz
// (numeric, clock_sync=false) rates are left untouched.
//
// "1/2" (half a bar) maps to the minim, which is its exact equivalent in 4/4 —
// the firmware's own 4/4 parity test has asserted that pair since the rework
// (tests/unit/test_div_meter4_parity.py). The minim was briefly not offered, so
// this migration snapped it to a crotchet instead and played such patches at
// twice their speed; restoring the option (MDL-365) makes it exact again.
//
// "1/3" (a bar triplet, 1 1/3 beats) has no offered equivalent — the minim
// triplet stays cut — so it still snaps to the nearest offered duration, the
// crotchet. That one rare case does change, even in 4/4; noted in the release
// notes.
const BAR_FRACTION_TO_NOTE_VALUE = {
  '1/16': '1/4b',   // semiquaver
  '1/12': '1/3b',   // quaver triplet
  '1/8':  '1/2b',   // quaver
  '1/6':  '2/3b',   // crotchet triplet
  '1/4':  '1b',     // crotchet
  '1/3':  '1b',     // 1⅓ beats (minim triplet), not offered → nearest: crotchet
  '1/2':  '2b',     // minim — exact in 4/4
};

export default {
  schema_version: 3,
  migrate(config) {
    for (const patch of config.patches ?? []) {
      for (const effect of patch.effects ?? []) {
        const mapped = BAR_FRACTION_TO_NOTE_VALUE[effect.rate];
        if (mapped) effect.rate = mapped;
      }
    }
  },
};
